class CountriesDropdown{
    constructor(place) {
        if(!place) throw new Error('Place has required')
        this.place = place
        
        if(!this.place.querySelector('[data-countries-dropdown-trigger-box]')) throw new Error('data-countries-dropdown-trigger-box has required')
        this.triggerBox = this.place.querySelector('[data-countries-dropdown-trigger-box]')

        if(!this.place.querySelector('[data-countries-dropdown-trigger]')) throw new Error('data-countries-dropdown-trigger has required')
        this.trigger = this.place.querySelector('[data-countries-dropdown-trigger]')

        if(!this.place.querySelector('[data-countries-dropdown-list]')) throw new Error('data-countries-dropdown-list has required')
        this.list = this.place.querySelector('[data-countries-dropdown-list]')

        this.isOpen = false
        this.init()
    }
    init(){
        this.trigger.addEventListener('click', e => {
            this.open()
        })
    }
    open(){
        this.triggerBox.classList.add('d-none')
        this.list.classList.remove('d-none')
    }
}
document.addEventListener('DOMContentLoaded', e => {
    let allCountriesDropdownBoxesOnPage = document.querySelectorAll('[data-countries-dropdown-box]')

    for(let i = 0; i < allCountriesDropdownBoxesOnPage.length; i++){
        let place = allCountriesDropdownBoxesOnPage[i]
        new CountriesDropdown(place)
    }
})
